import Setting2FA from './Setting2FA'

export default Setting2FA;